<button
  type="button"
  class="gung-btn btn text-center {{ classes }}"
  [class.btn-with-icon]="icon"
  [class.btn-with-icon-right]="icon && iconPosition === 'right'"
  (click)="handleClick()"
  [disabled]="loading || disable"
>
  @if (icon) {
    <span class="btn-icon" [class.btn-icon-right]="iconPosition === 'right'"><i class="{{ icon }}"></i></span>
  }
  @if(!loading){
    <span>{{ label | translate }}</span>
  }@else{
    <i class="fa fa-spinner fa-spin"></i>
  }
  
  
</button>
